import { MARQUEE_ITEMS } from "@/data/content";

const Marquee = ({ items = MARQUEE_ITEMS }) => {
  const row = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-ice/10 bg-space/60 py-5"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee items-center gap-10 pr-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-sm font-medium tracking-[0.4em] text-silver/80">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-electric/70 shadow-[0_0_8px_rgba(0,168,255,0.8)]" />
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-abyss to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-abyss to-transparent" />
    </div>
  );
};

export default Marquee;
